export default "__VITE_ASSET__DX$$2kOi__"